import Vue from 'vue'
import store from '@/store'
import VueRouter from 'vue-router'
import { getToken } from '@/utils/auth'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

Vue.use(VueRouter)

NProgress.configure({ showSpinner: false })

const routes = [
  {path: '/',redirect:'/login'},
  {path: '/login',component:() => import('@/views/Login')}
]

const router = new VueRouter({
  routes: routes,
  mode: 'history'
})

router.beforeEach(async(to, from, next) => {
  NProgress.start()
  const token = getToken()
  if( !token && to.path !== '/login'){//如果没有登录，跳转到登录页
      next({path:'/login'})
      NProgress.done()
  }else if(!token && to.path === '/login'){//如果没有登录，并且当前路径是登录页，直接放行
      next()
      NProgress.done()
  }else{//如果已经登录，
    if(!store.state.tool.hasGetRoute){//如果没有获取过路由，就获取路由
        store.dispatch('tool/getRouteList').then(() => {
        router.addRoutes(store.state.tool.routeList)
        router.addRoutes([{ path: '*', redirect: '/404', hidden: true }])
        next({...to, replace: true})
        NProgress.done()
      })
    }else{
      if (to.path === '/login') {
        next({ path: '/home' })
        NProgress.done()
      } else {
        next()
        NProgress.done()
      }
    }
  }
})

export default router
